// extracted by mini-css-extract-plugin
export default {"dropZoneContainer":"FileUploadDropZone_dropZoneContainer__37Sff"};